import {useCallback, useEffect, useState} from 'react';
import { safeParseResponse } from '../../utils';
import { authorizedPost } from '../api-authorization/AuthorizedFetch';

const useCode = function(content) {
  const [loading, setLoading ] = useState(true);
  const [code, setCode] = useState(null);

  const getCode = useCallback(async (content) => {
    const response = await authorizedPost("api/quick-codes", { content });
    const { code } = await safeParseResponse(response);

    setCode(code);
    setLoading(false);
  }, [setLoading, setCode]);

  useEffect(() => {
    getCode(content);
  }, [content, getCode]);

  return {
    loading,
    code
  }
}

export default useCode;